var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticStyle: {
      "width": "90%",
      "margin": "0 5%",
      "margin-top": "20px"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "height": "30px",
      "width": "25%"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v("社保编号：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.from.social_security_no))])], 1)], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v("医保编号：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.from.medical_insurance_no))])], 1)], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v("保险类别：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.from.insurance_type))])], 1)], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v("五险参保开始月份：\n                        ")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.from.insured_begin_date))])], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v("缴纳社保城市：\n                        ")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.from.insured_city))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v("缴纳类别：\n                        ")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.from.payment_type))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v("雇主出险记录：\n                        ")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "plain": "",
      "size": "mini"
    },
    on: {
      "click": _vm.dangerStatus
    }
  }, [_vm._v("出险记录")])], 1)], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v("雇主出险状态：\n                        ")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.from.entry_type))])], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v("是否缴纳公积金：\n                        ")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.from.is_accumulation_fund_title))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v("公积金编号：\n                        ")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.from.accumulation_fund_no))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v("公积金基数：\n                        ")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.from.provident_fund_base))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v("缴纳账户：\n                        ")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.from.payment_account_name))])], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v("五险缴纳账户：\n                        ")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.from.five_risks_account))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v("养老三险基数：\n                        ")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.from.aged_three_insurance))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v("生育医疗保险基数：\n                        ")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.from.birth_insurance))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v("生育医疗保险基数：\n                        ")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.from.is_insurance_medical))])], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.出险记录,
      "visible": _vm.dangerStatusType,
      "width": "30%",
      "center": "true",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dangerStatusType = $event
      }
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#F0F0F0',
        color: '#000000'
      },
      "data": _vm.danger,
      "tooltip-effect": "dark",
      "height": "300"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "danger_dete",
      "label": "出险时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "settlement_status",
      "label": "理赔情况",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": function($event) {
        return _vm.dangerSavesp()
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32dafb9e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Ygxxlb/tabs/insurance.vue
// module id = null
// module chunks = 